document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('[data-nn-exit-panel]');
  if (!panel) return;

  const storageKey = 'nn_exit_seen';
  if (sessionStorage.getItem(storageKey)) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  let armed = false;

  const open = () => {
    if (sessionStorage.getItem(storageKey)) return;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    sessionStorage.setItem(storageKey, '1');
    document.body.classList.add('nn-exit-open');
  };

  const close = () => {
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nn-exit-open');
  };

  panel.querySelectorAll('[data-nn-exit-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  setTimeout(() => {
    armed = true;
  }, 12000);

  // Desktop: cursor leaving the top of the viewport.
  document.addEventListener('mouseout', (e) => {
    if (!armed || !isDesktop()) return;
    if (e.clientY > 0) return;
    if (e.relatedTarget || e.toElement) return;
    open();
  });

  // Mobile: a sustained scroll back up after real browsing depth
  // is the closest signal to leaving.
  let lastY = window.scrollY;
  let upDistance = 0;
  let sawDepth = false;

  window.addEventListener(
    'scroll',
    () => {
      if (!armed || isDesktop()) return;
      const y = window.scrollY;
      if (y > window.innerHeight * 1.5) sawDepth = true;
      if (y < lastY) {
        upDistance += lastY - y;
      } else {
        upDistance = 0;
      }
      lastY = y;
      if (sawDepth && upDistance > 700 && y < window.innerHeight) open();
    },
    { passive: true }
  );
});
